import { render, staticRenderFns } from "./pointOrder.vue?vue&type=template&id=78f891d3&scoped=true&"
import script from "./pointOrder.vue?vue&type=script&lang=js&"
export * from "./pointOrder.vue?vue&type=script&lang=js&"
import style0 from "./pointOrder.vue?vue&type=style&index=0&id=78f891d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f891d3",
  null
  
)

export default component.exports